import { render } from "./SectionPartnerReferenceItem.vue?vue&type=template&id=69229c85&scoped=true"
import script from "./SectionPartnerReferenceItem.vue?vue&type=script&lang=js"
export * from "./SectionPartnerReferenceItem.vue?vue&type=script&lang=js"

import "./SectionPartnerReferenceItem.vue?vue&type=style&index=0&id=69229c85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69229c85"]])

export default __exports__